"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKFieldTile = void 0;
var gds_ux_components_1 = require("@granular/gds-ux-components");
var common_1 = require("@granular/gds-ux-components/lib/common");
var react_1 = __importDefault(require("react"));
require("./GKFieldTile.css");
var GKGeoThumbnailSVG_1 = require("./GKGeoThumbnailSVG");
/**
 * The GKFieldTile is used to represent a field consistently across the Granular Platform.
 * A field tile requires a field id and displays the field name, area, and field shape
 * as a GKGeoThumbnail.
 *
 * The GKFieldTile serves as the most basic building block of the field list and can be
 * included elsewhere where there is need to display a field's data.
 */
var GKFieldTile = function (props) {
    var mergedProps = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-field-tile",
        className: "no-gutters align-items-center flex-nowrap beta",
    });
    var addBefore = mergedProps.addBefore, addOn = mergedProps.addOn, area = mergedProps.area, fieldName = mergedProps.fieldName, farmName = mergedProps.farmName, headingLevel = mergedProps.headingLevel, shape = mergedProps.shape, thumbnailSvg = mergedProps.thumbnailSvg, id = mergedProps.id, children = mergedProps.children, restProps = __rest(mergedProps, ["addBefore", "addOn", "area", "fieldName", "farmName", "headingLevel", "shape", "thumbnailSvg", "id", "children"]);
    return (react_1.default.createElement(gds_ux_components_1.Row, __assign({ id: id }, restProps),
        addBefore && (react_1.default.createElement(gds_ux_components_1.Col, { xs: "auto", className: "gk-field-tile-addbefore d-flex mr-3" }, addBefore)),
        (thumbnailSvg || shape) && (react_1.default.createElement(gds_ux_components_1.Col, { xs: "auto" }, thumbnailSvg ? (react_1.default.createElement(GKGeoThumbnailSVG_1.GKGeoThumbnailSVG, { id: id + "-thumbnail", base64Svg: thumbnailSvg })) : (react_1.default.createElement(gds_ux_components_1.GKGeoThumbnail, { shape: shape, id: id + "-thumbnail" })))),
        children ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(gds_ux_components_1.Col, { className: "flex-grow-1 flex-shrink-1 text-truncate" },
                react_1.default.createElement(gds_ux_components_1.Row, null,
                    react_1.default.createElement(gds_ux_components_1.Col, { className: "flex-grow-1 gk-field-tile-text-container ml-4 text-truncate" },
                        react_1.default.createElement("div", null,
                            /**
                             * Allow user to define heading level of the component,
                             * or default to <span>
                             */
                            react_1.default.createElement(headingLevel ? headingLevel : "span", {
                                title: fieldName,
                                className: "d-block mb-2 text-left text-truncate gk-field-tile-heading font-weight-bold text-dark",
                            }, fieldName),
                            react_1.default.createElement("div", { className: "m-0 text-left text-truncate text-muted gk-field-tile-text", "data-qa": "field-tile-farm-name" },
                                area,
                                farmName && react_1.default.createElement("span", null,
                                    " | ",
                                    farmName)))),
                    addOn && (react_1.default.createElement(gds_ux_components_1.Col, { xs: "auto", className: "gk-field-tile-addon d-flex justify-content-end text-truncate" }, addOn))),
                children && (react_1.default.createElement("div", { className: "flex-grow-1 gk-field-tile-text-container text-muted ml-4" },
                    react_1.default.createElement("div", { className: "mt-2 gk-field-tile-children", "data-qa": "field-tile-children" }, children)))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(gds_ux_components_1.Col, { className: "flex-grow-1 flex-shrink-1 text-truncate" },
                react_1.default.createElement("div", { className: "gk-field-tile-text-container ml-4" },
                    /**
                     * Allow user to define heading level of the component,
                     * or default to <span>
                     */
                    react_1.default.createElement(headingLevel ? headingLevel : "span", {
                        title: fieldName,
                        className: "d-block mb-2 text-left text-truncate gk-field-tile-heading font-weight-bold text-dark",
                    }, fieldName),
                    react_1.default.createElement("div", { className: "m-0 text-left text-truncate text-muted gk-field-tile-text", "data-qa": "field-tile-farm-name" },
                        area,
                        farmName && react_1.default.createElement("span", null,
                            " | ",
                            farmName)))),
            addOn && (react_1.default.createElement(gds_ux_components_1.Col, { xs: "auto", className: "gk-field-tile-addon d-flex justify-content-end" }, addOn))))));
};
exports.GKFieldTile = GKFieldTile;
